import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose, pure } from 'utils/react';
import styles from './Range.scss';

const getTooltipStyle = value => `calc(${value}% + (${8 - value * 0.15}px))`;
const Range = ({
  input: { onChange, value },
  name,
  min,
  max,
  step,
  markers,
}) => {
  const ref = useRef();
  const tooltipRef = useRef();
  const handleRangeGradientColor = (localValue) => {
    const currentValue = ((localValue - min) / (max - min)) * 100;
    ref.current.style.background = `linear-gradient(to right, 
      #88BB40 0%, 
      #88BB40 ${currentValue}%, 
      #88BB4030 ${currentValue}%, 
      #88BB4030 100%)`;
    tooltipRef.current.style.left = getTooltipStyle(currentValue);
  };
  useEffect(() => {
    handleRangeGradientColor(value);
    tooltipRef.current.style.display = 'none';
  });
  const handleShowTooltip = () => {
    tooltipRef.current.style.display = 'block';
  };

  const handleHideTooltip = () => {
    tooltipRef.current.style.display = 'none';
  };
  return (
    <div className={styles.range}>
      <input
        type="range"
        name={name}
        min={min}
        max={max}
        step={step}
        ref={ref}
        onChange={(e) => {
          onChange(e.target.value);
          handleRangeGradientColor(e.target.value);
          handleShowTooltip();
        }}
        onMouseEnter={handleShowTooltip}
        onMouseLeave={handleHideTooltip}
        onFocus={handleShowTooltip}
        onClick={handleShowTooltip}
        value={value}
      />
      <output className={styles.tooltip} ref={tooltipRef}>
        {value}
      </output>
      <div className={styles.markers}>
        {markers.map((marker, index) => (
          <div
            key={marker.value}
            className={styles.markerContainer}
            style={{
              width:
                index === markers.length - 1
                  ? 0
                  : `${100 / markers.length - 1}%`,
              display: 'flex',
              flexDirection: 'column',
              alignItems: index === markers.length - 1 ? 'center' : 'unset',
            }}
          >
            <div className={styles.marker}>|</div>
            {marker?.label && (
              <div className={styles.markerLabel}>{marker.label}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

Range.propTypes = {
  name: PropTypes.string.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  markers: PropTypes.array,
};

Range.defaultProps = {
  min: 0,
  max: 100,
  step: 0.1,
  markers: [],
};

export default compose(pure())(Range);
